import * as React from 'react';
import { Field } from 'redux-form';
import { useHistory } from 'react-router-dom';

import {
  FormWrapper,
  ButtonsWrapper,
  Error
} from './styled';

import { normalizeText } from '@app/src/utils/normalizers';
import { FieldGroup } from '@app/src/components/Field';
import { Button } from '@app/src/components/Button';
import { required, email } from '@app/src/utils/validations';
import { RenderInput } from '@app/src/views/CipGeneration/generateForm/components/RenderInput';
import { RenderSelect } from '@app/src/views/CipGeneration/generateForm/components/RenderSelect';
import { ModalContainer } from './../Modal';

const roles = [
  {
    value: '0',
    label: 'Operador'
  },
  {
    value: '1',
    label: 'Administrador'
  }
];


export const Form: React.FC<any> = ({
  handleSubmit,
  errorMessage,
  isFetching,
  message,
  reset,
  sessionRol
}) => {

  const history = useHistory();
  const handleClick = () => {
    history.push('/usuarios');
  }

  return(
    <FormWrapper data-test="userDetailNewUserForm" onSubmit={handleSubmit}>
      <Error>{errorMessage}</Error>
      <FieldGroup>
        <Field
          name="name"
          type="text"
          maxLength="50"
          label="Nombre (*)"
          dataSpan="userDetailNameError"
          portionWidth={1/2}
          data-test="userDetailName"
          component={RenderInput}
          validate={[required]}
          normalize={normalizeText}
        />
        <Field
          name="lastName"
          type="text"
          maxLength="80"
          label="Apellidos (*)"
          dataSpan="userDetailLastNameError"
          portionWidth={1/2}
          data-test="userDetailLastName"
          component={RenderInput}
          validate={[required]}
          normalize={normalizeText}
        />
      </FieldGroup>
      <FieldGroup>
        <Field
          name="email"
          type="text"
          maxLength="100"
          label="Email (*)"
          portionWidth={1/2}
          data-test="userDetailEmail"
          component={RenderInput}
          validate={[required, email]}
        />
        <Field
          name="rol"
          label="Rol"
          portionWidth={1/2}
          data-test="userDetailRole"
          component={RenderSelect}
          options={roles}
        />
      </FieldGroup>
      <ButtonsWrapper>
        <Button data-test="userDetailButtonBack" type="button" onClick={() => handleClick()} >Volver</Button>
        <Button data-test="userDetailButtonSave" primary type="submit" loading={isFetching}>Crear</Button>
      </ButtonsWrapper>
      <ModalContainer data-test="modal" message={message} reset={reset} sessionRol={sessionRol} />
    </FormWrapper>
  );
};
